import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface AppointmentModel {
  id: number;
  name: string;
  dateDebut: string;
  dateFin: string;
  nameType: string;
  nameTeacher: string;
  beginHour: string;
  endHour: string;
  color: string;
  confirmed: string;
}

export interface ApiResponse<T> {
  error: string | null;
  response: T;
}

@Injectable({ providedIn: 'root' })
export class RdvparentalService {
  private baseUrl = `${environment.apiUrl.replace(/\/$/, '')}/rdvparental`;

  constructor(private http: HttpClient) {}

  getAvailableAppointments(batchId: number, studentId: number, userIdGuardian: number): Observable<ApiResponse<AppointmentModel[]>> {
    return this.http.get<ApiResponse<AppointmentModel[]>>(
      `${this.baseUrl}/disponibilte/${batchId}/${studentId}/${userIdGuardian}`
    );
  }

  listReservations(batchId: number, studentId: number, userIdGuardian: number): Observable<ApiResponse<{ listResrvationConfirmed: AppointmentModel[]; listResrvationNotConfirmed: AppointmentModel[]; msg: string; type: string }>> {
    return this.http.get<ApiResponse<{ listResrvationConfirmed: AppointmentModel[]; listResrvationNotConfirmed: AppointmentModel[]; msg: string; type: string }>>(
      `${this.baseUrl}/listreservation/${batchId}/${studentId}/${userIdGuardian}`
    );
  }

  createReservation(batchId: number, studentId: number, userIdGuardian: number, idAppointment: number): Observable<ApiResponse<{ msg: string; type: string }>> {
    return this.http.get<ApiResponse<{ msg: string; type: string }>>(
      `${this.baseUrl}/create/${batchId}/${studentId}/${userIdGuardian}/${idAppointment}`
    );
  }
}
